export default __webpack_public_path__ + "static/media/jarvisflow.c9615efe.jpg";